// Toggle functionality for product specifications
document.querySelectorAll(".compremore-info").forEach((element) => {
  element.addEventListener("click", function (e) {
    e.preventDefault();

    // Toggle active class on button
    this.classList.toggle("active");

    // Find all hidden features in both containers
    const infoTable = this.closest(".info_table_product");
    const productFeatured = this.closest(".product_featured");

    // Get all hidden list items
    const hiddenItems = infoTable
      ? infoTable.querySelectorAll(".hidden_Features")
      : [];

    // Toggle each hidden item with animation
    hiddenItems.forEach((item) => {
      if (item.style.display === "none" || !item.style.display) {
        item.style.display = "block";
        item.style.height = "0";
        item.style.overflow = "hidden";
        item.style.transition = "height 0.3s ease";

        // Trigger reflow
        void item.offsetHeight;

        item.style.height = item.scrollHeight + "px";

        // Remove inline styles after animation completes
        setTimeout(() => {
          item.style.height = "";
          item.style.overflow = "";
          item.style.transition = "";
        }, 300);
      } else {
        item.style.height = item.scrollHeight + "px";
        item.style.overflow = "hidden";
        item.style.transition = "height 0.3s ease";

        // Trigger reflow
        void item.offsetHeight;

        item.style.height = "0";

        // Set display:none after animation completes
        setTimeout(() => {
          item.style.display = "none";
          item.style.height = "";
          item.style.overflow = "";
          item.style.transition = "";
        }, 300);
      }
    });
  });
});

// For the compremore-info-height functionality (if needed)
document.querySelectorAll(".compremore-info-height").forEach((element) => {
  element.addEventListener("click", function (e) {
    const featureRow = this.closest(".feature-row__text");
    if (featureRow) {
      const ulElement = featureRow.querySelector(".ul");
      ulElement.classList.toggle("active");
    }
    this.classList.toggle("active");
  });
});
